export default __webpack_public_path__ + "static/media/ORCID-Badge-v-01-COLLECT.a0c9f7f6.svg";